import type { ModuleManifest } from '@airin/shared-types'
import faqTranslations from './i18n'

export const manifest: ModuleManifest & {
  translations: { en: Record<string, any>; de: Record<string, any> }
} = {
  key: 'faq',
  name: 'FAQ',
  version: '1.0.0',
  description:
    'Frequently Asked Questions with categories, multi-language translations and tenant-scoped visibility.',
  author: 'T�V AI Lab',

  requiredSettings: [],

  optionalSettings: [
    {
      key: 'defaultLanguage',
      label: 'faq.manifest.settings.defaultLanguage.label',
      type: 'string',
      description:
        "Language code used as fallback when no translation exists for the visitor's language.",
      defaultValue: 'de'
    },
    {
      key: 'showCategories',
      label: 'faq.manifest.settings.showCategories.label',
      type: 'boolean',
      description: 'If enabled, FAQs are grouped by category in the frontend.',
      defaultValue: true
    },
    {
      key: 'allowSearch',
      label: 'faq.manifest.settings.allowSearch.label',
      type: 'boolean',
      description: 'If enabled, a search field is shown in the FAQ frontend view.',
      defaultValue: true
    }
  ],

  menuItems: [
    {
      key: 'faq-overview',
      label: 'faq.manifest.menuItems.overview',
      icon: 'pi pi-question-circle',
      path: '/faqs_categories',
      order: 60,
      roles: ['ai_lab_admin', 'mandant_admin']
    },
    {
      key: 'faq-settings',
      label: 'faq.manifest.menuItems.settings',
      icon: 'pi pi-cog',
      path: '/faqs_categories/settings',
      parent: 'faq-overview',
      order: 0,
      roles: ['ai_lab_admin', 'mandant_admin']
    },
    {
      key: 'faq-faqs',
      label: 'faq.manifest.menuItems.faqs',
      icon: 'pi pi-list',
      path: '/faqs_categories/faqs',
      parent: 'faq-overview',
      order: 1,
      roles: ['ai_lab_admin', 'mandant_admin']
    },
    {
      key: 'faq-categories',
      label: 'faq.manifest.menuItems.categories',
      icon: 'pi pi-tag',
      path: '/faqs_categories/categories',
      parent: 'faq-overview',
      order: 2,
      roles: ['ai_lab_admin', 'mandant_admin']
    },
    {
      key: 'faq-translations',
      label: 'faq.manifest.menuItems.translations',
      icon: 'pi pi-language',
      path: '/faqs_categories/translations',
      parent: 'faq-overview',
      order: 3,
      roles: ['ai_lab_admin', 'mandant_admin']
    }
  ],

  themeSettings: [],

  flags: [
    {
      name: 'faq_tenant_visibility',
      description: 'Restrict FAQ category visibility to specific tenants',
      defaultValue: true
    }
  ],

  translations: {
    en: faqTranslations.en,
    de: faqTranslations.de
  }
}

export default manifest
